import { Button, Chip, List, ListItemButton, Divider, Grid, IconButton, Table, TableBody, TableCell, TableHead, TableRow, Typography, tableCellClasses } from '@mui/material';
import { FC, useEffect, useState } from 'react';

import NavigateBeforeOutlinedIcon from '@mui/icons-material/NavigateBeforeOutlined';
import Box from '@mui/material/Box';
import { useAppDispatch, useAppSelector } from "../../store/hooks";

import { fetchInvoices } from '../../store/invoiceStore/invoiceThunk';
import { fetchReport } from '../../store/reportStore/reportThunk';

import styled_ from "@emotion/styled";
import LoadingButton from '@mui/lab/LoadingButton';
import moment from 'moment';
import { ApiStatus } from "../../utils/api.types";
import { Utils, VocuherCategory, ReportTypes } from "../../utils/common-utils";
import Filters from '../Filters/Filters';
import generatePDF, { Resolution, Margin, Options } from "react-to-pdf";
import { useNavigate } from 'react-router-dom';
import io from 'socket.io-client';

import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';

import Collapse from '@mui/material/Collapse';
import ListSubheader from '@mui/material/ListSubheader';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import DraftsIcon from '@mui/icons-material/Drafts';
import SendIcon from '@mui/icons-material/Send';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import StarBorder from '@mui/icons-material/StarBorder';

import { styled } from '@mui/material/styles';
import ReportsTable from './ReportsTable';
import ReportsDashboard from './ReportsDashboard';

const FireNav = styled(List)<{ component?: React.ElementType }>({
  '& .MuiListItemButton-root': {
    paddingLeft: 24,
    paddingRight: 24,
  },
  '& .MuiListItemIcon-root': {
    minWidth: 0,
    marginRight: 16,
  },
  '& .MuiSvgIcon-root': {
    fontSize: 20,
  },
});


interface ReportDashboardProps {
  type: string;
}


const ReportDashboard: FC<ReportDashboardProps> = (props) => {
  const dispatch = useAppDispatch();
  const { invoices, status } = useAppSelector(state => state.invoices);
  const { permissions, selectedAccount } = useAppSelector(state => state.auth);
  const [filters, setFilters] = useState('');
  const [filterData, setFilterData] = useState<any>();
  const navigate = useNavigate();

  const [messages, setMessages] = useState<any>();

  const handleNavigateTo = (reportType: string) => {
    // console.log("_refInvoiceId ==== ", _refInvoiceId);
    if (reportType && reportType == ReportTypes.PARTY_LEDGER) {
      navigate(`/report/party-ledger-dn`);
    } else if (reportType && reportType == ReportTypes.GST_SALES) {
      navigate(`/report/sale`);
    } else if (reportType && reportType == ReportTypes.PARTY_LEDGER_REPORT) {
      navigate(`/report/party-ledger`);
    }
  };


  return (
    <>
      {/* <Grid container p={0} spacing={2} position={'fixed'} mt={-2} zIndex={0}>
        <Grid item xs={8}>
          <Box sx={{ borderRadius: '12px', border: '3px solid #e9ecf1', backgroundColor: '#fff' }}>
            <Grid container>
              <Grid {...{ xs: 12, sm: 8, md: 4, lg: 12, p: 2, pl: 2, pt: 1.5, bgcolor: '#e9ecf1' }} style={{ borderTopLeftRadius: 8, borderTopRightRadius: 8, height: 50 }} >
                <div style={{ float: 'right', marginTop: -5, marginRight: -5 }}>
                  <CustomBreadcrumbs/>
                </div>
                <IconButton
                  style={{ float: 'left', color: '#545454', backgroundColor: '#f5f5f5', border: 'none', height: 35, width: 35, marginTop: -5, marginRight: 15, marginLeft: -5 }}
                  size='small' >
                  <NavigateBeforeOutlinedIcon style={{ fontSize: 20 }} />
                </IconButton>
                <h3 style={{ marginTop: -1, fontWeight: 600 }}>{'Party Ledger'}</h3>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid> */}
      <Grid container spacing={2} p={0.5} mb={1}>
        {/* Need this container to keep show filter on screen */}
      </Grid>
      <Grid container spacing={2} >
            <Grid item xs={12}>           
          {/* <Box sx={{ width: '100%' }} className={'c-card2'}>
            <Grid container p={2} >

              <Grid xs={4}>

                <IconButton
                  style={{ float: 'left', color: '#545454', backgroundColor: '#f5f5f5', border: 'none', height: 25, width: 25, marginRight: 10 }}
                  size='small' >
                  <NavigateBeforeOutlinedIcon style={{ fontSize: 20 }} />
                </IconButton>
                <h3 style={{ marginTop: -1, fontWeight: 600 }}>{'Favourites'}</h3>

                <Grid container style={{paddingTop: 15}}>

                <List
                  sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper'}}
                  component="nav"
                  aria-labelledby="nested-list-subheader" >
                  <ListItemButton>
                    <ListItemIcon>
                      <SendIcon />
                    </ListItemIcon>
                    <ListItemText primary="Sent mail" />
                  </ListItemButton>
                  <ListItemButton>
                    <ListItemIcon>
                      <DraftsIcon />
                    </ListItemIcon>
                    <ListItemText primary="Drafts" />
                  </ListItemButton>
                  <ListItemButton >
                    <ListItemIcon>
                      <InboxIcon />
                    </ListItemIcon>
                    <ListItemText primary="Inbox" />
                    {open ? <ExpandLess /> : <ExpandMore />}
                  </ListItemButton>
                  <Collapse in={true} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      <ListItemButton sx={{ pl: 4 }}>
                        <ListItemIcon>
                          <StarBorder />
                        </ListItemIcon>
                        <ListItemText primary="Starred" />
                      </ListItemButton>
                    </List>
                  </Collapse>
                </List>

                </Grid>


              </Grid>










              <Grid xs={12} style={{ textAlign: 'center' }}>
                <Button
                  onClick={() => handleNavigateTo(ReportTypes.GST_SALES)}
                  size='small'
                  variant="contained"
                  style={{ color: '#488dff', backgroundColor: '#fff', border: '0.5px solid #488dff', height: 35, borderRadius: 7, margin: 10 }}>
                  Sale Report (GSTR-1)
                </Button>
                <Button
                  onClick={() => handleNavigateTo(ReportTypes.PARTY_LEDGER)}
                  size='small'
                  variant="contained"
                  style={{ color: '#488dff', backgroundColor: '#fff', border: '0.5px solid #488dff', height: 35, borderRadius: 7, margin: 10 }}>
                  Party Voucher Report
                </Button>

                <Button
                  onClick={() => handleNavigateTo(ReportTypes.PARTY_LEDGER_REPORT)}
                  size='small'
                  variant="contained"
                  style={{ color: '#488dff', backgroundColor: '#fff', border: '0.5px solid #488dff', height: 35, borderRadius: 7, margin: 10 }}>
                  Party Ledger Report
                </Button>
                
              </Grid>
              <Grid xs={2} >

              </Grid>
            </Grid>
          </Box> */}
          <ReportsDashboard/>
        </Grid>
      </Grid>
    </>
  );
}
export default ReportDashboard;

// location /whatapp-api/ {
//   proxy_pass http://139.59.76.108:4001/;
// }

// location /socket.io/ {
//   proxy_pass http://139.59.76.108:4001/;
//   proxy_http_version 1.1;
//   proxy_set_header Upgrade $http_upgrade;
//   proxy_set_header Connection "upgrade";
//   proxy_set_header Host $host;
//   add_header Access-Control-Allow-Origin "http://139.59.76.108:3011";
//   add_header Access-Control-Allow-Credentials true;
// }